export const providers = [
  {
    id: 'IDDATAWEB',
    vendorName: 'IDDATAWEB',
    name: 'ID Dataweb',
    icon: 'IDDataweb',
    status: 2,
    description:
      'Prompt users to answer knowledge-based authentication (KBA) questions.',
  },
  {
    id: '1KOSMOS',
    vendorName: '1KOSMOS',
    name: '1Kosmos',
    icon: 'OneKosmos',
    status: 2,
    description:
      'Prompt users to answer knowledge-based authentication (KBA) questions.',
  },
];

export const PROVIDER_NAMES = {
  IDDATAWEB: 'IDDATAWEB',
  '1KOSMOS': '1KOSMOS',
};

export const CONFIG_ATTRIBUTES = {
  USERNAME: 'USERNAME',
  PASSWORD: 'PASSWORD',
  APIKEY: 'APIKEY',
  REDIRECT_URL: 'REDIRECT_URL',
};

export const initialENVOptions = [
  { label: 'Production', value: 'Production' },
  { label: 'Preproduction', value: 'Preproduction' },
];

export const initialDocumentOptions = [
  { label: 'Passport', value: 'ppt_object' },
  { label: 'Driver’s License', value: 'dl_object' },
  { label: 'Any Document', value: 'idcard_object' },
];

export interface Provider {
  id: string;
  name: string;
  icon: string;
  description: string;
}

export interface Option {
  value: string;
  label: string;
}

export const PROVIDERS_STATUS = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
} as const;

export const initialMenuOptions = [
  {
    label: 'Settings',
    value: 'Settings',
  },
];
